import { createAsyncThunk } from '@reduxjs/toolkit';
import ReportTypeService from '~/api/reportTypeService';
import AuthApi from '~/api/auth';
import ReportTypeAdapters from '~/helpers/adapters/reportType';
import DictionaryApi from '~/api/dictionaries';
import { Company, Dictionary } from '~/types/general';
import { IJCState } from '~/types/models/jcState';
import { IJCStatus } from '~/types/models/jcStatus';
import { IReportType } from '~/types/models/reportType';
import { adaptCompaniesDist, jobCardStateAdapter, jobCardStatusAdapter } from '../helpers';
import { IDepartmentResponse } from '~/types/response/department';
import { ISubDepartmentResponse } from '~/types/response/subDepartment';
import { IWorkstationResponse } from '~/types/response/workstation';

export const fetchJcStatuses = createAsyncThunk<IJCStatus[], undefined>('main/fetchJcStatuses', async (_payload) => {
  try {
    const data = await DictionaryApi.getJcStatusesFromApi();
    const adaptStatuses = data.map(jobCardStatusAdapter);
    return adaptStatuses;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchJcStates = createAsyncThunk<IJCState[], undefined>('main/fetchJcStates', async (_) => {
  try {
    const data = await DictionaryApi.getJcStatesFromApi();
    const adaptStates = data.map(jobCardStateAdapter);
    return adaptStates;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchReportTypes = createAsyncThunk<IReportType[], undefined>('main/fetchReportTypes', async () => {
  try {
    const reportTypes = await ReportTypeService.getAll();
    return ReportTypeAdapters.adaptResponseAll(reportTypes);
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchBranches = createAsyncThunk<Dictionary[], any>('main/fetchBranches', async (companyId) => {
  try {
    const { Branches = [] } = await DictionaryApi.getBranches(companyId, {
      select: 'Branches',
    });
    return Branches;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchCompanies = createAsyncThunk<Company[]>('main/fetchCompanies', async () => {
  try {
    const companies = await DictionaryApi.getCompanies();

    const adaptCompanies = companies.map(adaptCompaniesDist);
    return adaptCompanies;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchDepartments = createAsyncThunk<IDepartmentResponse[]>('main/fetchDepartments', async () => {
  try {
    const departments = await DictionaryApi.getDepartmentsFromApi();
    return departments;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchSubDepartments = createAsyncThunk<ISubDepartmentResponse[]>('main/fetchSubDepartments', async () => {
  try {
    const subDepartments = await DictionaryApi.getSubDepartmentsFromApi();
    return subDepartments;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchWorkstations = createAsyncThunk<IWorkstationResponse[]>('main/fetchWorkstations', async () => {
  try {
    const workstations = await DictionaryApi.getWorkstationsFromApi();
    return workstations;
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const fetchLogo = createAsyncThunk<string>('main/fetchLogo', async () => {
  try {
    const { data } = await AuthApi.AuthLogo();
    return data || '';
  } catch (error) {
    console.error(error);
    return '';
  }
});
